module.exports = __webpack_public_path__ + "img/F2.563f1b6b.png";